// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { 
//   Building2, 
//   MapPin, 
//   Download, 
//   CheckCircle, 
//   Home,
//   Wifi,
//   Dumbbell,
//   Waves,
//   Trees,
//   Car,
//   Shield,
//   Phone,
//   Mail,
//   ArrowRight,
//   ChevronDown,
//   Star,
//   TrendingUp,
//   Users,
//   Award
// } from 'lucide-react';

// const MaaSrinivasamPage = () => {
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const highlights = [
//     { icon: <Home className="w-6 h-6" />, title: '2 & 3 BHK', subtitle: 'Luxury Apartments' },
//     { icon: <MapPin className="w-6 h-6" />, title: 'Isnapur', subtitle: 'Mumbai Highway' },
//     { icon: <Building2 className="w-6 h-6" />, title: '15,000 Sq.Ft', subtitle: 'Clubhouse' },
//     { icon: <Star className="w-6 h-6" />, title: '₹59.99 L', subtitle: 'Starting Price' }
//   ];

//   const amenities = [
//     { icon: <Waves className="w-8 h-8" />, title: 'Indoor Swimming Pool', desc: 'Temperature controlled pool' },
//     { icon: <Dumbbell className="w-8 h-8" />, title: 'AC Gymnasium', desc: 'State-of-the-art equipment' },
//     { icon: <Users className="w-8 h-8" />, title: '7 Guest Rooms', desc: 'Fully furnished AC rooms' },
//     { icon: <Building2 className="w-8 h-8" />, title: '2 Banquet Halls', desc: 'AC halls for events' },
//     { icon: <Trees className="w-8 h-8" />, title: '3 Center Parks', desc: 'Landscaped gardens' },
//     { icon: <Car className="w-8 h-8" />, title: 'EV Charging', desc: 'Every parking space' },
//     { icon: <Wifi className="w-8 h-8" />, title: 'Indoor Games', desc: 'Recreation room' },
//     { icon: <Shield className="w-8 h-8" />, title: '24/7 Security', desc: 'Complete safety' }
//   ];

//   const features = [
//     'Strategic Location on Mumbai Highway',
//     'Easy Access to Outer Ring Road (ORR)',
//     'Proximity to IT and Business Parks',
//     'Reputed Schools & Hospitals Nearby',
//     'Expansive Terraces',
//     'Premium Fittings & Fixtures',
//     '24/7 Power Backup',
//     'Landscaped Gardens & Jogging Tracks'
//   ];

//   const advantages = [
//     {
//       icon: <TrendingUp className="w-10 h-10" />,
//       title: 'High ROI Potential',
//       desc: 'Rapid appreciation in property values due to strategic location and infrastructure development'
//     },
//     {
//       icon: <Award className="w-10 h-10" />,
//       title: 'Quality Living Environment',
//       desc: 'Thoughtful design and premium amenities ensure a comfortable and luxurious lifestyle'
//     },
//     {
//       icon: <Users className="w-10 h-10" />,
//       title: 'Community Living',
//       desc: 'Be part of a vibrant and close-knit community with opportunities to socialize'
//     },
//     {
//       icon: <CheckCircle className="w-10 h-10" />,
//       title: 'Transparency & Trust',
//       desc: "Vedamsa's legacy ensures complete transparency in every transaction"
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-[#f5f3f0]">
//       {/* Hero Section with Gradient Overlay */}
//       <section className="relative h-screen w-full overflow-hidden">
//         {/* Background Image */}
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1920')`,
//           }}
//         ></div>
        
//         {/* Gradient Overlay */}
//         <div className="absolute inset-0 bg-gradient-to-br from-[#3d2817]/90 via-[#3d2817]/70 to-transparent"></div>

//         {/* Hero Content */}
//         <div className="relative z-20 h-full flex items-center">
//           <div className="max-w-7xl mx-auto px-6 w-full">
//             <div className="max-w-3xl">
//               {/* Badge */}
//               <div className="inline-block mb-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-6 py-2">
//                 <span className="text-white text-sm font-medium">By Vedamsa - 30 Years of Excellence</span>
//               </div>

//               {/* Main Heading */}
//               <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
//                 MAA Srinivasam
//               </h1>
              
//               <p className="text-2xl md:text-3xl text-white/90 mb-4 font-light">
//                 Luxury 2 & 3 BHK Apartments
//               </p>
              
//               <p className="text-xl text-white/80 mb-8">
//                 in Isnapur, Mumbai Highway
//               </p>

//               {/* Price Tag */}
//               <div className="inline-block bg-white rounded-2xl px-8 py-4 mb-10 shadow-2xl">
//                 <p className="text-gray-600 text-sm mb-1">Starting from</p>
//                 <p className="text-4xl font-bold text-[#3d2817]">₹59.99 Lakhs</p>
//               </div>

//               {/* CTA Buttons */}
//               <div className="flex flex-col sm:flex-row gap-4">
//                 <button className="group bg-white text-gray-900 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 flex items-center justify-center space-x-2">
//                   <Download className="w-5 h-5" />
//                   <span>Download Brochure</span>
//                 </button>
//                 <a 
//                   href="tel:+918885852266"
//                   className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300 flex items-center justify-center space-x-2"
//                 >
//                   <Phone className="w-5 h-5" />
//                   <span>Schedule Site Visit</span>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
//           <ChevronDown className="w-8 h-8 text-white/60" />
//         </div>
//       </section>

//       {/* Quick Highlights Bar */}
//       <section className="bg-white py-8 shadow-lg relative z-30 -mt-20">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//             {highlights.map((item, index) => (
//               <div key={index} className="flex items-center space-x-4 p-4 bg-[#f5f3f0] rounded-lg hover:shadow-md transition-shadow duration-300">
//                 <div className="flex-shrink-0 w-12 h-12 bg-[#3d2817] text-white rounded-lg flex items-center justify-center">
//                   {item.icon}
//                 </div>
//                 <div>
//                   <p className="font-bold text-gray-900">{item.title}</p>
//                   <p className="text-sm text-gray-600">{item.subtitle}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* About Section */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [WELCOME TO]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Where Luxury Meets Nature
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
//               Welcome to MAA Srinivasam, perfectly located in the upcoming Isnapur Municipality on Mumbai Highway, offering a harmonious blend of luxury and nature. Experience stunning views of 3 Center Parks and choose from meticulously designed 2 BHK and 3 BHK premium apartments equipped with EV charging points in every parking space.
//             </p>
//           </div>

//           {/* Image Gallery Grid */}
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             <div className="md:col-span-2 relative overflow-hidden rounded-2xl shadow-2xl group h-[500px]">
//               <img 
//                 src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200"
//                 alt="Luxury Living Room"
//                 className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
//               <div className="absolute bottom-6 left-6 text-white">
//                 <p className="text-2xl font-bold">Premium Interiors</p>
//                 <p className="text-white/80">Thoughtfully Designed Spaces</p>
//               </div>
//             </div>

//             <div className="space-y-6">
//               <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[237px]">
//                 <img 
//                   src="https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=600"
//                   alt="Modern Kitchen"
//                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-black/30"></div>
//               </div>
//               <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[237px]">
//                 <img 
//                   src="https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=600"
//                   alt="Bedroom"
//                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-black/30"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Clubhouse Section with Dark Background */}
//       <section className="py-20 px-6 bg-gray-900 text-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-400 font-medium mb-6 block">
//               [WORLD-CLASS AMENITIES]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold mb-6">
//               15,000 Sq. Ft. Premium Clubhouse
//             </h2>
//             <p className="text-gray-300 text-lg leading-relaxed max-w-3xl mx-auto">
//               Experience world-class amenities in our sprawling clubhouse featuring state-of-the-art facilities designed for your comfort and entertainment.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {amenities.map((amenity, index) => (
//               <div 
//                 key={index}
//                 className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-xl hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-2"
//               >
//                 <div className="w-16 h-16 bg-[#3d2817] text-white rounded-xl flex items-center justify-center mb-4">
//                   {amenity.icon}
//                 </div>
//                 <h3 className="text-xl font-bold mb-2">{amenity.title}</h3>
//                 <p className="text-gray-400 text-sm">{amenity.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Floor Plans Section */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//             {/* Left - Content */}
//             <div>
//               <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//                 [FLOOR PLANS]
//               </span>
//               <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//                 Well-Designed<br />Living Spaces
//               </h2>
//               <p className="text-gray-600 text-lg leading-relaxed mb-8">
//                 Each apartment at MAA SRINIVASAM is crafted to perfection with spacious layouts, premium fittings, and elegant interiors. Whether you choose a 2BHK or 3BHK unit, you'll experience thoughtful design and optimal utilization of space.
//               </p>

//               <div className="space-y-6 mb-8">
//                 <div className="flex items-start space-x-4 p-4 bg-[#f5f3f0] rounded-lg">
//                   <CheckCircle className="w-6 h-6 text-[#3d2817] flex-shrink-0 mt-1" />
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-1">2 BHK Apartments</h4>
//                     <p className="text-gray-600 text-sm">Perfect for small families and working professionals</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start space-x-4 p-4 bg-[#f5f3f0] rounded-lg">
//                   <CheckCircle className="w-6 h-6 text-[#3d2817] flex-shrink-0 mt-1" />
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-1">3 BHK Apartments</h4>
//                     <p className="text-gray-600 text-sm">Ideal for larger families seeking luxury and comfort</p>
//                   </div>
//                 </div>
//               </div>

//               <button className="group bg-[#3d2817] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#2d1f10] transition-all duration-300 shadow-lg hover:shadow-xl flex items-center space-x-2">
//                 <Download className="w-5 h-5" />
//                 <span>Download Floor Plans</span>
//                 <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
//               </button>
//             </div>

//             {/* Right - Image */}
//             <div className="relative">
//               <div className="relative overflow-hidden rounded-2xl shadow-2xl">
//                 <img 
//                   src="https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800"
//                   alt="Floor Plan"
//                   className="w-full h-[600px] object-cover"
//                 />
//               </div>
//               {/* Floating Card */}
//               <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-2xl">
//                 <p className="text-sm text-gray-600 mb-1">Starting from</p>
//                 <p className="text-3xl font-bold text-[#3d2817]">₹59.99 L</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Location & Connectivity */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [LOCATION ADVANTAGES]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Strategic Location in Isnapur
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
//               Located in Isnapur, a rapidly growing suburb of Hyderabad, offering unparalleled connectivity and convenience. Just minutes away from key hubs like Patancheru, BHEL Township, and Financial District.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
//             {features.map((feature, index) => (
//               <div 
//                 key={index}
//                 className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 flex items-start space-x-3"
//               >
//                 <CheckCircle className="w-5 h-5 text-[#3d2817] flex-shrink-0 mt-0.5" />
//                 <p className="text-gray-700 font-medium">{feature}</p>
//               </div>
//             ))}
//           </div>

//           {/* Map Placeholder */}
//           <div className="relative overflow-hidden rounded-2xl shadow-2xl h-[500px]">
//             <img 
//               src="https://images.unsplash.com/photo-1524661135-423995f22d0b?w=1200"
//               alt="Location Map"
//               className="w-full h-full object-cover"
//             />
//             <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
//             <div className="absolute bottom-8 left-8 text-white">
//               <MapPin className="w-8 h-8 mb-2" />
//               <p className="text-2xl font-bold">Isnapur, Hyderabad</p>
//               <p className="text-white/80">Mumbai Highway - Prime Location</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Investment Advantages */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [WHY INVEST]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Advantages of Investing in<br />MAA Srinivasam
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {advantages.map((advantage, index) => (
//               <div 
//                 key={index}
//                 className="bg-[#f5f3f0] p-8 rounded-2xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
//               >
//                 <div className="w-20 h-20 bg-white text-[#3d2817] rounded-xl flex items-center justify-center mb-6 shadow-md">
//                   {advantage.icon}
//                 </div>
//                 <h3 className="text-2xl font-bold text-gray-900 mb-4">{advantage.title}</h3>
//                 <p className="text-gray-600 leading-relaxed">{advantage.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Vedamsa Legacy */}
//       <section className="py-20 px-6 bg-gray-900 text-white">
//         <div className="max-w-6xl mx-auto text-center">
//           <span className="text-sm uppercase tracking-[0.3em] text-gray-400 font-medium mb-6 block">
//             [TRUSTED BUILDER]
//           </span>
//           <h2 className="text-4xl md:text-5xl font-bold mb-8">
//             Vedamsa - Nearly 30 Years of Excellence
//           </h2>
//           <p className="text-gray-300 text-lg leading-relaxed max-w-4xl mx-auto mb-12">
//             When you think of trust, quality, and reliability in the construction industry, Vedamsa is a name that stands tall in Hyderabad. With nearly three decades of experience, Vedamsa has built a reputation as a premier construction company known for its commitment to customer satisfaction and excellence. With over 3000 happy customers and an impressive portfolio, Vedamsa continues to shape Hyderabad's real estate landscape.
//           </p>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-xl">
//               <p className="text-5xl font-bold mb-2">30+</p>
//               <p className="text-gray-400">Years of Excellence</p>
//             </div>
//             <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-xl">
//               <p className="text-5xl font-bold mb-2">3000+</p>
//               <p className="text-gray-400">Happy Customers</p>
//             </div>
//             <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-xl">
//               <p className="text-5xl font-bold mb-2">100%</p>
//               <p className="text-gray-400">Transparency & Trust</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="relative py-32 px-6 overflow-hidden">
//         {/* Background Image */}
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920')`,
//           }}
//         ></div>
//         <div className="absolute inset-0 bg-gradient-to-r from-[#3d2817]/95 to-[#3d2817]/80"></div>

//         {/* Content */}
//         <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
//           <h2 className="text-4xl md:text-6xl font-bold mb-6">
//             Your Dream Home Awaits
//           </h2>
//           <p className="text-xl text-white/90 mb-4">
//             Starting from ₹59.99 Lakhs
//           </p>
//           <p className="text-lg text-white/80 mb-12">
//             2 & 3 BHK Luxury Apartments in Isnapur, Hyderabad
//           </p>

//           <div className="flex flex-col sm:flex-row gap-6 justify-center">
//             <button className="bg-white text-gray-900 px-10 py-5 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 text-lg flex items-center justify-center space-x-2">
//               <Download className="w-6 h-6" />
//               <span>Download Brochure</span>
//             </button>
//             <a 
//               href="tel:+918885852266"
//               className="bg-transparent border-2 border-white text-white px-10 py-5 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300 text-lg flex items-center justify-center space-x-2"
//             >
//               <Phone className="w-6 h-6" />
//               <span>Call: +91 8885852266</span>
//             </a>
//           </div>

//           <div className="mt-12 pt-12 border-t border-white/20">
//             <p className="text-white/80 mb-4">For more details or to schedule a site visit:</p>
//             <div className="flex flex-col sm:flex-row gap-6 justify-center text-white">
//               <a href="tel:+918885852266" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors">
//                 <Phone className="w-5 h-5" />
//                 <span>+91 8885852266</span>
//               </a>
//               <a href="mailto:Vedamsa@gmail.com" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors">
//                 <Mail className="w-5 h-5" />
//                 <span>Vedamsa@gmail.com</span>
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-[#2d1f10] text-white py-12 px-6">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
//             <div className="md:col-span-2">
//               <div className="flex items-center space-x-3 mb-4">
//                 <div className="bg-white text-gray-900 p-2 rounded">
//                   <Building2 className="w-6 h-6" />
//                 </div>
//                 <span className="text-2xl font-bold">Vedamsa</span>
//               </div>
//               <p className="text-gray-400 mb-4">Building Dreams, Creating Futures</p>
//               <p className="text-gray-500 text-sm">MAA Srinivasam - Luxury Apartments in Isnapur, Hyderabad</p>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Quick Links</h4>
//               <div className="space-y-2 text-gray-400">
//                 <Link to="/" className="block hover:text-white transition-colors">Home</Link>
//                 <Link to="/about" className="block hover:text-white transition-colors">About Vedamsa</Link>
//                 <Link to="/contact" className="block hover:text-white transition-colors">Contact Us</Link>
//               </div>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Contact</h4>
//               <div className="space-y-2 text-gray-400">
//                 <p>Isnapur, Hyderabad</p>
//                 <p>+91 8885852266</p>
//                 <p>Vedamsa@gmail.com</p>
//               </div>
//             </div>
//           </div>

//           <div className="border-t border-gray-700 pt-8 text-center">
//             <p className="text-gray-500 text-sm">© 2025 Vedamsa. All rights reserved. | MAA Srinivasam</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default MaaSrinivasamPage;

// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { 
//   Building2, 
//   MapPin, 
//   Download, 
//   CheckCircle, 
//   Home,
//   Wifi,
//   Dumbbell,
//   Waves,
//   Trees,
//   Car,
//   Shield,
//   Phone,
//   Mail,
//   ArrowRight,
//   ChevronDown,
//   Star,
//   TrendingUp,
//   Users,
//   Award,
//   ExternalLink
// } from 'lucide-react';
// import srinivas from  '../Images/1-FRONT-1-scaled-1.jpg';
// import floorPlan1 from '../Images/Floor_Plans_Left.jpg';
// import floorPlan2 from '../Images/Floor_Plans_Right.jpg';
// import poster1 from '../Images/Poster-9.png';
// import poster2 from '../Images/Poster-17.png';
// import poster3 from '../Images/Poster-18.png';
// import poster4 from '../Images/Poster-19.png';
// import clubhouse from '../Images/CLUB-HOUSE1-scaled-1.jpg';
// import map1 from '../Images/MAA-SRINIVASAM-2_page-0010-scaled-1.jpg';

// const MaaSrinivasamPage = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const scrollContainerRef = useRef(null);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Auto-scroll gallery
//   useEffect(() => {
//     const container = scrollContainerRef.current;
//     if (!container) return;

//     let scrollAmount = 0;
//     const scrollStep = 1;
//     const scrollInterval = 30;

//     const autoScroll = setInterval(() => {
//       if (container.scrollLeft >= container.scrollWidth - container.clientWidth) {
//         container.scrollLeft = 0;
//         scrollAmount = 0;
//       } else {
//         container.scrollLeft += scrollStep;
//         scrollAmount += scrollStep;
//       }
//     }, scrollInterval);

//     return () => clearInterval(autoScroll);
//   }, []);

//   const highlights = [
//     { icon: <Home className="w-6 h-6" />, title: '2 & 3 BHK', subtitle: 'Luxury Apartments' },
//     { icon: <MapPin className="w-6 h-6" />, title: 'Isnapur', subtitle: 'Mumbai Highway' },
//     { icon: <Building2 className="w-6 h-6" />, title: '15,000 Sq.Ft', subtitle: 'Clubhouse' },
//     { icon: <Star className="w-6 h-6" />, title: '₹59.99 L', subtitle: 'Starting Price' }
//   ];

//   const galleryImages = [
//     poster1,
//     poster2,
//     poster3,
//     poster4,
//     'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800',
//     'https://images.unsplash.com/photo-1615875221248-e7c68f54eb2d?w=800'
//   ];

//   const amenities = [
//     { icon: <Waves className="w-8 h-8" />, title: 'Indoor Swimming Pool', desc: 'Temperature controlled pool' },
//     { icon: <Dumbbell className="w-8 h-8" />, title: 'AC Gymnasium', desc: 'State-of-the-art equipment' },
//     { icon: <Users className="w-8 h-8" />, title: '7 Guest Rooms', desc: 'Fully furnished AC rooms' },
//     { icon: <Building2 className="w-8 h-8" />, title: '2 Banquet Halls', desc: 'AC halls for events' },
//     { icon: <Trees className="w-8 h-8" />, title: '3 Center Parks', desc: 'Landscaped gardens' },
//     { icon: <Car className="w-8 h-8" />, title: 'EV Charging', desc: 'Every parking space' },
//     { icon: <Wifi className="w-8 h-8" />, title: 'Indoor Games', desc: 'Recreation room' },
//     { icon: <Shield className="w-8 h-8" />, title: '24/7 Security', desc: 'Complete safety' }
//   ];

//   const features = [
//     'Strategic Location on Mumbai Highway',
//     'Easy Access to Outer Ring Road (ORR)',
//     'Proximity to IT and Business Parks',
//     'Reputed Schools & Hospitals Nearby',
//     'Expansive Terraces',
//     'Premium Fittings & Fixtures',
//     '24/7 Power Backup',
//     'Landscaped Gardens & Jogging Tracks'
//   ];

//   const advantages = [
//     {
//       icon: <TrendingUp className="w-10 h-10" />,
//       title: 'High ROI Potential',
//       desc: 'Rapid appreciation in property values due to strategic location and infrastructure development'
//     },
//     {
//       icon: <Award className="w-10 h-10" />,
//       title: 'Quality Living Environment',
//       desc: 'Thoughtful design and premium amenities ensure a comfortable and luxurious lifestyle'
//     },
//     {
//       icon: <Users className="w-10 h-10" />,
//       title: 'Community Living',
//       desc: 'Be part of a vibrant and close-knit community with opportunities to socialize'
//     },
//     {
//       icon: <CheckCircle className="w-10 h-10" />,
//       title: 'Transparency & Trust',
//       desc: "Vedamsa's legacy ensures complete transparency in every transaction"
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-[#f5f3f0]">
//       {/* Hero Section with Gradient Overlay */}
//       <section className="relative h-screen w-full overflow-hidden">
//         {/* Background Image */}
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('${srinivas}')`,
//           }}
//         ></div>
        
//         {/* Gradient Overlay */}
//         {/* <div className="absolute inset-0 bg-gradient-to-br from-[#8B7355]/90 via-[#6B5744]/70 to-transparent"></div> */}

//         {/* Hero Content */}
//         <div className="relative z-20 h-full flex items-center">
//           <div className="max-w-7xl mx-auto px-6 w-full">
//             <div className="max-w-3xl">
//               {/* Badge */}
//               <div className="inline-block mb-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-6 py-2">
//                 <span className="text-white text-sm font-medium">By Vedamsa - 30 Years of Excellence</span>
//               </div>

//               {/* Main Heading */}
//               <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
//                 MAA Srinivasam
//               </h1>
              
//               <p className="text-2xl md:text-3xl text-white/90 mb-4 font-light">
//                 Luxury 2 & 3 BHK Apartments
//               </p>
              
//               <p className="text-xl text-white/80 mb-8">
//                 in Isnapur, Mumbai Highway
//               </p>

//               {/* Price Tag */}
//               <div className="inline-block bg-white rounded-2xl px-8 py-4 mb-10 shadow-2xl">
//                 <p className="text-gray-600 text-sm mb-1">Starting from</p>
//                 <p className="text-4xl font-bold text-[#8B7355]">₹59.99 Lakhs</p>
//               </div>

//               {/* CTA Buttons */}
//               <div className="flex flex-col sm:flex-row gap-4">
//                 <button className="group bg-white text-gray-900 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 flex items-center justify-center space-x-2">
//                   <Download className="w-5 h-5" />
//                   <span>Download Brochure</span>
//                 </button>
//                 <a 
//                   href="tel:+918885852266"
//                   className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300 flex items-center justify-center space-x-2"
//                 >
//                   <Phone className="w-5 h-5" />
//                   <span>Schedule Site Visit</span>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
//           <ChevronDown className="w-8 h-8 text-white/60" />
//         </div>
//       </section>

//       {/* Quick Highlights Bar */}
//       <section className="bg-white py-8 shadow-lg relative z-30 -mt-20">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//             {highlights.map((item, index) => (
//               <div key={index} className="flex items-center space-x-4 p-4 bg-[#f5f3f0] rounded-lg hover:shadow-md transition-shadow duration-300">
//                 <div className="flex-shrink-0 w-12 h-12 bg-[#8B7355] text-white rounded-lg flex items-center justify-center">
//                   {item.icon}
//                 </div>
//                 <div>
//                   <p className="font-bold text-gray-900">{item.title}</p>
//                   <p className="text-sm text-gray-600">{item.subtitle}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* About Section */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [WELCOME TO]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Where Luxury Meets Nature
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
//               Welcome to MAA Srinivasam, perfectly located in the upcoming Isnapur Municipality on Mumbai Highway, offering a harmonious blend of luxury and nature. Experience stunning views of 3 Center Parks and choose from meticulously designed 2 BHK and 3 BHK premium apartments equipped with EV charging points in every parking space.
//             </p>
//           </div>

//           {/* Image Gallery Grid */}
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             <div className="md:col-span-2 relative overflow-hidden rounded-2xl shadow-2xl group h-[500px]">
//               <img 
//                 src={clubhouse}
//                 alt="Luxury Living Room"
//                 className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
//               <div className="absolute bottom-6 left-6 text-white">
//                 <p className="text-2xl font-bold">Premium Interiors</p>
//                 <p className="text-white/80">Thoughtfully Designed Spaces</p>
//               </div>
//             </div>

//             <div className="space-y-6">
//               <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[237px]">
//                 <img 
//                   src={map1}
//                   alt="Modern Kitchen"
//                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-black/30"></div>
//               </div>
//               <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[237px]">
//                 <img 
//                   src="https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=600"
//                   alt="Bedroom"
//                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-black/30"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Auto-Scrolling Gallery Section */}
//    <section className="py-20 px-6 bg-white overflow-hidden">
//   <div className="max-w-7xl mx-auto mb-12">
//     <div className="text-center">
//       <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//         [GALLERY]
//       </span>
//       <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//         Experience Luxury Living
//       </h2>
//       <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
//         Explore our beautifully designed interiors and premium amenities that make MAA Srinivasam your perfect home
//       </p>
//     </div>
//   </div>

//   {/* Auto-scrolling container */}
//   <div 
//     ref={scrollContainerRef}
//     className="flex space-x-6 overflow-x-hidden"
//     style={{ scrollBehavior: 'smooth' }}
//   >
//     {/* Double the images for seamless loop */}
//     {[...galleryImages, ...galleryImages].map((image, index) => (
//       <div 
//         key={index}
//         className="flex-shrink-0 w-[500px] md:w-[650px] lg:w-[750px] h-[600px] md:h-[700px] lg:h-[800px] relative overflow-hidden rounded-2xl shadow-xl group"
//       >
//         <img 
//           src={image}
//           alt={`Gallery ${index + 1}`}
//           className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
//         />
//         <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//       </div>
//     ))}
//   </div>
// </section>

//       {/* Floor Plans Section - Updated */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [FLOOR PLANS]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Well-Designed Floor Plans
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
//               Each apartment at MAA SRINIVASAM is crafted to perfection with spacious layouts, premium fittings, and elegant interiors. Whether you choose a 2BHK or 3BHK unit, you'll experience thoughtful design and optimal utilization of space.
//             </p>
//           </div>

//           {/* Two Floor Plan Images Side by Side */}
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
//             {/* 2BHK Plan */}
//             <div className="bg-white rounded-2xl shadow-xl overflow-hidden group hover:shadow-2xl transition-all duration-300">
//               <div className="relative h-[500px] overflow-hidden">
//                 <img 
//                   src={floorPlan1}
//                   alt="2BHK Floor Plan"
//                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//                 />
//                 {/* <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div> */}
//                 <div className="absolute bottom-6 left-6 right-6">
//                   {/* <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4"> */}
//                     {/* <h3 className="text-2xl font-bold text-gray-900 mb-2">2 BHK Apartments</h3>
//                     <p className="text-gray-600 mb-4">Perfect for small families and working professionals</p> */}
//                     {/* <div className="flex flex-wrap gap-2 mb-4">s
//                       <span className="px-3 py-1 bg-[#8B7355]/10 text-[#8B7355] rounded-lg text-sm font-medium">
//                         Spacious Layout
//                       </span>
//                       <span className="px-3 py-1 bg-[#8B7355]/10 text-[#8B7355] rounded-lg text-sm font-medium">
//                         Modern Kitchen
//                       </span>
//                       <span className="px-3 py-1 bg-[#8B7355]/10 text-[#8B7355] rounded-lg text-sm font-medium">
//                         2 Bathrooms
//                       </span>
//                     </div> */}
//                     {/* <button className="w-full bg-[#8B7355] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#6B5744] transition-all duration-300 flex items-center justify-center space-x-2">
//                       <Download className="w-5 h-5" />
//                       <span>Download 2BHK Plan</span>
//                     </button> */}
//                   {/* </div> */}
//                 </div>
//               </div>
//             </div>

//             {/* 3BHK Plan */}
//             <div className="bg-white rounded-2xl shadow-xl overflow-hidden group hover:shadow-2xl transition-all duration-300">
//               <div className="relative h-[500px] overflow-hidden">
//                 <img 
//                   src={floorPlan2}
//                   alt="3BHK Floor Plan"
//                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//                 />
//                 {/* <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div> */}
//                 {/* <div className="absolute bottom-6 left-6 right-6">
//                   <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4">
//                     <h3 className="text-2xl font-bold text-gray-900 mb-2">3 BHK Apartments</h3>
//                     <p className="text-gray-600 mb-4">Ideal for larger families seeking luxury and comfort</p>
//                     <div className="flex flex-wrap gap-2 mb-4">
//                       <span className="px-3 py-1 bg-[#8B7355]/10 text-[#8B7355] rounded-lg text-sm font-medium">
//                         Premium Design
//                       </span>
//                       <span className="px-3 py-1 bg-[#8B7355]/10 text-[#8B7355] rounded-lg text-sm font-medium">
//                         Study Room
//                       </span>
//                       <span className="px-3 py-1 bg-[#8B7355]/10 text-[#8B7355] rounded-lg text-sm font-medium">
//                         3 Bathrooms
//                       </span>
//                     </div>
//                     <button className="w-full bg-[#8B7355] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#6B5744] transition-all duration-300 flex items-center justify-center space-x-2">
//                       <Download className="w-5 h-5" />
//                       <span>Download 3BHK Plan</span>
//                     </button>
//                   </div>
//                 </div> */}
//               </div>
//             </div>
//           </div>

//           {/* Bottom Description */}
//           <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
//             <div className="max-w-4xl mx-auto text-center">
//               <p className="text-gray-700 text-lg leading-relaxed mb-8">
//                 If you're planning to buy apartments in Isnapur, MAA SRINIVASAM offers the perfect combination of affordability and opulence.
//               </p>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div className="flex items-start space-x-4 p-6 bg-[#f5f3f0] rounded-xl">
//                   <CheckCircle className="w-6 h-6 text-[#8B7355] flex-shrink-0 mt-1" />
//                   <div className="text-left">
//                     <h4 className="font-bold text-gray-900 mb-2">Premium Fittings</h4>
//                     <p className="text-gray-600 text-sm">High-quality fixtures and elegant interiors throughout</p>
//                   </div>
//                 </div>
                
//                 <div className="flex items-start space-x-4 p-6 bg-[#f5f3f0] rounded-xl">
//                   <CheckCircle className="w-6 h-6 text-[#8B7355] flex-shrink-0 mt-1" />
//                   <div className="text-left">
//                     <h4 className="font-bold text-gray-900 mb-2">Optimal Space Utilization</h4>
//                     <p className="text-gray-600 text-sm">Thoughtful design maximizing every square foot</p>
//                   </div>
//                 </div>

//                 <div className="flex items-start space-x-4 p-6 bg-[#f5f3f0] rounded-xl">
//                   <CheckCircle className="w-6 h-6 text-[#8B7355] flex-shrink-0 mt-1" />
//                   <div className="text-left">
//                     <h4 className="font-bold text-gray-900 mb-2">Spacious Layouts</h4>
//                     <p className="text-gray-600 text-sm">Generous living areas with excellent ventilation</p>
//                   </div>
//                 </div>

//                 <div className="flex items-start space-x-4 p-6 bg-[#f5f3f0] rounded-xl">
//                   <CheckCircle className="w-6 h-6 text-[#8B7355] flex-shrink-0 mt-1" />
//                   <div className="text-left">
//                     <h4 className="font-bold text-gray-900 mb-2">Modern Amenities</h4>
//                     <p className="text-gray-600 text-sm">Contemporary facilities for comfortable living</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Clubhouse Section with Dark Background */}
//       <section className="py-20 px-6 bg-gray-900 text-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-400 font-medium mb-6 block">
//               [WORLD-CLASS AMENITIES]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold mb-6">
//               15,000 Sq. Ft. Premium Clubhouse
//             </h2>
//             <p className="text-gray-300 text-lg leading-relaxed max-w-3xl mx-auto">
//               Experience world-class amenities in our sprawling clubhouse featuring state-of-the-art facilities designed for your comfort and entertainment.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {amenities.map((amenity, index) => (
//               <div 
//                 key={index}
//                 className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-xl hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-2"
//               >
//                 <div className="w-16 h-16 bg-[#8B7355] text-white rounded-xl flex items-center justify-center mb-4">
//                   {amenity.icon}
//                 </div>
//                 <h3 className="text-xl font-bold mb-2">{amenity.title}</h3>
//                 <p className="text-gray-400 text-sm">{amenity.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Location & Connectivity with Map Link */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [LOCATION ADVANTAGES]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Strategic Location in Isnapur
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
//               Located in Isnapur, a rapidly growing suburb of Hyderabad, offering unparalleled connectivity and convenience. Just minutes away from key hubs like Patancheru, BHEL Township, and Financial District.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
//             {features.map((feature, index) => (
//               <div 
//                 key={index}
//                 className="bg-[#f5f3f0] p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 flex items-start space-x-3"
//               >
//                 <CheckCircle className="w-5 h-5 text-[#8B7355] flex-shrink-0 mt-0.5" />
//                 <p className="text-gray-700 font-medium">{feature}</p>
//               </div>
//             ))}
//           </div>

//           {/* Interactive Map with Link */}
//           <div className="relative overflow-hidden rounded-2xl shadow-2xl h-[500px] group">
//             <iframe
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.7441616893837!2d78.19588450000001!3d17.5527712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf12a5f2662cf%3A0xc385d29a5612e332!2sVedamsa%20Infrastructure%20pvt%20ltd!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
//               width="100%"
//               height="100%"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//               className="w-full h-full"
//             ></iframe>
            
//             {/* Overlay with Link */}
//             <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none"></div>
//             <div className="absolute bottom-8 left-8 right-8 pointer-events-auto">
//               <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-2xl">
//                 <div className="flex items-start justify-between">
//                   <div className="flex-1">
//                     <MapPin className="w-8 h-8 text-[#8B7355] mb-2" />
//                     <p className="text-2xl font-bold text-gray-900 mb-2">MAA Srinivasam, Isnapur</p>
//                     <p className="text-gray-600 mb-4">Mumbai Highway, Hyderabad - Prime Location</p>
//                   </div>
//                 </div>
//                 <a 
//                   href="https://www.google.com/maps/place/Vedamsa+Infrastructure+pvt+ltd/@17.552771,78.195885,10z/data=!4m6!3m5!1s0x3bcbf12a5f2662cf:0xc385d29a5612e332!8m2!3d17.5527712!4d78.1958845!16s%2Fg%2F11vyt53tgr?hl=en-US&entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="inline-flex items-center space-x-2 bg-[#8B7355] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#6B5744] transition-all duration-300 shadow-lg hover:shadow-xl"
//                 >
//                   <span>Get Directions</span>
//                   <ExternalLink className="w-5 h-5" />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Investment Advantages */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [WHY INVEST]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Advantages of Investing in<br />MAA Srinivasam
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {advantages.map((advantage, index) => (
//               <div 
//                 key={index}
//                 className="bg-white p-8 rounded-2xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
//               >
//                 <div className="w-20 h-20 bg-[#8B7355]/10 text-[#8B7355] rounded-xl flex items-center justify-center mb-6 shadow-md">
//                   {advantage.icon}
//                 </div>
//                 <h3 className="text-2xl font-bold text-gray-900 mb-4">{advantage.title}</h3>
//                 <p className="text-gray-600 leading-relaxed">{advantage.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Vedamsa Legacy */}
//       <section className="py-20 px-6 bg-gray-900 text-white">
//         <div className="max-w-6xl mx-auto text-center">
//           <span className="text-sm uppercase tracking-[0.3em] text-gray-400 font-medium mb-6 block">
//             [TRUSTED BUILDER]
//           </span>
//           <h2 className="text-4xl md:text-5xl font-bold mb-8">
//             Vedamsa - Nearly 30 Years of Excellence
//           </h2>
//           <p className="text-gray-300 text-lg leading-relaxed max-w-4xl mx-auto mb-12">
//             When you think of trust, quality, and reliability in the construction industry, Vedamsa is a name that stands tall in Hyderabad. With nearly three decades of experience, Vedamsa has built a reputation as a premier construction company known for its commitment to customer satisfaction and excellence. With over 3000 happy customers and an impressive portfolio, Vedamsa continues to shape Hyderabad's real estate landscape.
//           </p>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-xl">
//               <p className="text-5xl font-bold mb-2">30+</p>
//               <p className="text-gray-400">Years of Excellence</p>
//             </div>
//             <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-xl">
//               <p className="text-5xl font-bold mb-2">3000+</p>
//               <p className="text-gray-400">Happy Customers</p>
//             </div>
//             <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-xl">
//               <p className="text-5xl font-bold mb-2">100%</p>
//               <p className="text-gray-400">Transparency & Trust</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Final CTA - Full Clear Image */}
//       <section className="relative h-screen overflow-hidden">
//         {/* Full Background Image */}
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920')`,
//           }}
//         ></div>

//         {/* Subtle overlay for text readability */}
//         <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

//         {/* Content */}
//         <div className="relative z-10 h-full flex items-center justify-center px-6">
//           <div className="max-w-4xl mx-auto text-center text-white">
//             <h2 className="text-5xl md:text-7xl font-bold mb-6 drop-shadow-2xl">
//               Your Dream Home Awaits
//             </h2>
//             <p className="text-2xl md:text-3xl text-white mb-4 font-light drop-shadow-lg">
//               Starting from ₹59.99 Lakhs
//             </p>
//             <p className="text-xl text-white/90 mb-12 drop-shadow-lg">
//               2 & 3 BHK Luxury Apartments in Isnapur, Hyderabad
//             </p>

//             <div className="flex flex-col sm:flex-row gap-6 justify-center">
//               <button className="bg-white text-gray-900 px-10 py-5 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 text-lg flex items-center justify-center space-x-2">
//                 <Download className="w-6 h-6" />
//                 <span>Download Brochure</span>
//               </button>
//               <a 
//                 href="tel:+918885852266"
//                 className="bg-[#8B7355] border-2 border-[#8B7355] text-white px-10 py-5 rounded-lg font-bold hover:bg-[#6B5744] hover:border-[#6B5744] transition-all duration-300 shadow-2xl text-lg flex items-center justify-center space-x-2"
//               >
//                 <Phone className="w-6 h-6" />
//                 <span>Call: +91 8885852266</span>
//               </a>
//             </div>

//             <div className="mt-12 pt-12 border-t border-white/30">
//               <p className="text-white/90 mb-4 drop-shadow-lg">For more details or to schedule a site visit:</p>
//               <div className="flex flex-col sm:flex-row gap-6 justify-center text-white">
//                 <a href="tel:+918885852266" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg">
//                   <Phone className="w-5 h-5" />
//                   <span>+91 8885852266</span>
//                 </a>
//                 <a href="mailto:Vedamsa@gmail.com" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg">
//                   <Mail className="w-5 h-5" />
//                   <span>Vedamsa@gmail.com</span>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-[#2d1f10] text-white py-12 px-6">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
//             <div className="md:col-span-2">
//               <div className="flex items-center space-x-3 mb-4">
//                 <div className="bg-white text-gray-900 p-2 rounded">
//                   <Building2 className="w-6 h-6" />
//                 </div>
//                 <span className="text-2xl font-bold">Vedamsa</span>
//               </div>
//               <p className="text-gray-400 mb-4">Building Dreams, Creating Futures</p>
//               <p className="text-gray-500 text-sm">MAA Srinivasam - Luxury Apartments in Isnapur, Hyderabad</p>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Quick Links</h4>
//               <div className="space-y-2 text-gray-400">
//                 <Link to="/" className="block hover:text-white transition-colors">Home</Link>
//                 <Link to="/about" className="block hover:text-white transition-colors">About Vedamsa</Link>
//                 <Link to="/contact" className="block hover:text-white transition-colors">Contact Us</Link>
//               </div>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Contact</h4>
//               <div className="space-y-2 text-gray-400">
//                 <p>Isnapur, Hyderabad</p>
//                 <p>+91 8885852266</p>
//                 <p>Vedamsa@gmail.com</p>
//               </div>
//             </div>
//           </div>

//           <div className="border-t border-gray-700 pt-8 text-center">
//             <p className="text-gray-500 text-sm">© 2025 Vedamsa. All rights reserved. | MAA Srinivasam</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default MaaSrinivasamPage;


import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { 
  Building2, 
  MapPin, 
  Download, 
  CheckCircle, 
  Home,
  Wifi,
  Dumbbell,
  Waves,
  Trees,
  Car,
  Shield,
  Phone,
  Mail,
  ArrowRight,
  ChevronDown,
  Star,
  TrendingUp,
  Users,
  Award,
  ExternalLink
} from 'lucide-react';
import srinivas from  '../Images/1-FRONT-1-scaled-1.jpg';
import floorPlan1 from '../Images/Floor_Plans_Left.jpg';
import floorPlan2 from '../Images/Floor_Plans_Right.jpg';
import poster1 from '../Images/Poster-9.png';
import poster2 from '../Images/Poster-17.png';
import poster3 from '../Images/Poster-18.png';
import poster4 from '../Images/Poster-19.png';
import clubhouse from '../Images/CLUB-HOUSE1-scaled-1.jpg';
import map1 from '../Images/MAA-SRINIVASAM-2_page-0010-scaled-1.jpg';
import brochurePDF from '../assets/MAA-SRINIVASAM-1 (1).pdf';

// PURE SILVER Reveal Image Component
const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsRevealed(true);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
          isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
        }`}
        style={{ transitionDelay: '800ms' }}
      />
      
      {/* PURE SILVER Gradient Mask */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
          isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
        }`}
        style={{ 
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
          background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
        }}
      />
      
      {/* Silver Shimmer */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
          isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
        }`}
        style={{ 
          transitionDelay: '300ms',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
        }}
      />
    </div>
  );
};

// Reveal Content Component
const RevealContent = ({ children, className = "", delay = 0, direction = 'up' }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  const getTransform = () => {
    if (direction === 'up') return isRevealed ? 'translate-y-0' : 'translate-y-[60px]';
    if (direction === 'down') return isRevealed ? 'translate-y-0' : '-translate-y-[60px]';
    if (direction === 'left') return isRevealed ? 'translate-x-0' : 'translate-x-[60px]';
    if (direction === 'right') return isRevealed ? 'translate-x-0' : '-translate-x-[60px]';
    return '';
  };
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
      } ${getTransform()} ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

const MaaSrinivasamPage = () => {
  const [scrolled, setScrolled] = useState(false);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-scroll gallery
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    let scrollAmount = 0;
    const scrollStep = 1;
    const scrollInterval = 30;

    const autoScroll = setInterval(() => {
      if (container.scrollLeft >= container.scrollWidth - container.clientWidth) {
        container.scrollLeft = 0;
        scrollAmount = 0;
      } else {
        container.scrollLeft += scrollStep;
        scrollAmount += scrollStep;
      }
    }, scrollInterval);

    return () => clearInterval(autoScroll);
  }, []);

  const highlights = [
    { icon: <Home className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />, title: '2 & 3 BHK', subtitle: 'Luxury Apartments' },
    { icon: <MapPin className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />, title: 'Isnapur', subtitle: 'Mumbai Highway' },
    { icon: <Building2 className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />, title: '15,000 Sq.Ft', subtitle: 'Clubhouse' },
    { icon: <Star className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />, title: '₹59.99 L', subtitle: 'Starting Price' }
  ];

  const galleryImages = [poster1, poster2, poster3, poster4];

  const amenities = [
    { icon: <Waves className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8" />, title: 'Indoor Swimming Pool', desc: 'Temperature controlled pool' },
    { icon: <Dumbbell className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8" />, title: 'AC Gymnasium', desc: 'State-of-the-art equipment' },
    { icon: <Users className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8" />, title: '7 Guest Rooms', desc: 'Fully furnished AC rooms' },
    { icon: <Building2 className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8" />, title: '2 Banquet Halls', desc: 'AC halls for events' },
    { icon: <Trees className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8" />, title: '3 Center Parks', desc: 'Landscaped gardens' },
    { icon: <Car className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8" />, title: 'EV Charging', desc: 'Every parking space' },
    { icon: <Wifi className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8" />, title: 'Indoor Games', desc: 'Recreation room' },
    { icon: <Shield className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8" />, title: '24/7 Security', desc: 'Complete safety' }
  ];

  const features = [
    'Strategic Location on Mumbai Highway',
    'Easy Access to Outer Ring Road (ORR)',
    'Proximity to IT and Business Parks',
    'Reputed Schools & Hospitals Nearby',
    'Expansive Terraces',
    'Premium Fittings & Fixtures',
    '24/7 Power Backup',
    'Landscaped Gardens & Jogging Tracks'
  ];

  const advantages = [
    {
      icon: <TrendingUp className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10" />,
      title: 'High ROI Potential',
      desc: 'Rapid appreciation in property values due to strategic location and infrastructure development'
    },
    {
      icon: <Award className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10" />,
      title: 'Quality Living Environment',
      desc: 'Thoughtful design and premium amenities ensure a comfortable and luxurious lifestyle'
    },
    {
      icon: <Users className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10" />,
      title: 'Community Living',
      desc: 'Be part of a vibrant and close-knit community with opportunities to socialize'
    },
    {
      icon: <CheckCircle className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10" />,
      title: 'Transparency & Trust',
      desc: "Vedamsa's legacy ensures complete transparency in every transaction"
    }
  ];

  return (
    <div className="min-h-screen bg-[#f5f3f0] overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-screen w-full overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center transition-transform duration-[8000ms] ease-out hover:scale-105"
          style={{ backgroundImage: `url('${srinivas}')` }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

        <div className="relative z-20 h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full">
            <div className="max-w-3xl">
              <RevealContent delay={100}>
                <div className="inline-block mb-4 sm:mb-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 sm:px-6 py-2">
                  <span className="text-white text-xs sm:text-sm font-medium">By Vedamsa - 30 Years of Excellence</span>
                </div>
              </RevealContent>

              <RevealContent delay={200}>
                <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white mb-4 sm:mb-6 leading-tight drop-shadow-2xl">
                  MAA Srinivasam
                </h1>
              </RevealContent>
              
              <RevealContent delay={300}>
                <p className="text-xl sm:text-2xl md:text-3xl text-white/90 mb-3 sm:mb-4 font-light drop-shadow-lg">
                  Luxury 2 & 3 BHK Apartments
                </p>
              </RevealContent>
              
              <RevealContent delay={400}>
                <p className="text-lg sm:text-xl md:text-2xl text-white/80 mb-6 sm:mb-8 drop-shadow-lg">
                  in Isnapur, Mumbai Highway
                </p>
              </RevealContent>

              <RevealContent delay={500}>
                <div className="inline-block bg-white rounded-2xl px-6 sm:px-8 py-3 sm:py-4 mb-8 sm:mb-10 shadow-2xl hover:scale-105 transition-transform duration-300">
                  <p className="text-gray-600 text-xs sm:text-sm mb-1">Starting from</p>
                  <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#8B7355]">₹59.99 Lakhs</p>
                </div>
              </RevealContent>

              <RevealContent delay={600}>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  {/* <button className="group bg-white text-gray-900 px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 flex items-center justify-center space-x-2 text-sm sm:text-base">
                    <Download className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span>Download Brochure</span>
                  </button> */}


<button 
  onClick={() => {
    const link = document.createElement('a');
    link.href = brochurePDF;
    link.download = 'MAA-Srinivasam-Brochure.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }}
  className="group bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 text-base sm:text-lg flex items-center justify-center space-x-2 relative overflow-hidden"
>
  <span className="relative z-10 flex items-center space-x-2">
    <Download className="w-5 h-5 sm:w-6 sm:h-6" />
    <span>Download Brochure</span>
  </span>
  <div className="absolute inset-0 bg-gradient-to-r from-[#C0C0C0] to-[#E8E8E8] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
</button>
                  <a 
                    href="tel:+918885852266"
                    className="bg-transparent border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:bg-white hover:text-gray-900 transition-all duration-500 flex items-center justify-center space-x-2 text-sm sm:text-base"
                  >
                    <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span className="hidden sm:inline">Schedule Site Visit</span>
                    <span className="sm:hidden">Book Visit</span>
                  </a>
                </div>
              </RevealContent>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
          <ChevronDown className="w-6 h-6 sm:w-8 sm:h-8 text-white/60" />
        </div>
      </section>

      {/* Quick Highlights Bar */}
      <section className="bg-white py-6 sm:py-8 shadow-lg relative z-30 -mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
            {highlights.map((item, index) => (
              <RevealContent key={index} delay={index * 100}>
                <div className="flex items-center space-x-2 sm:space-x-3 md:space-x-4 p-3 sm:p-4 bg-[#f5f3f0] rounded-xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                  <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#8B7355] text-white rounded-lg flex items-center justify-center">
                    {item.icon}
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-xs sm:text-sm md:text-base">{item.title}</p>
                    <p className="text-[10px] sm:text-xs md:text-sm text-gray-600">{item.subtitle}</p>
                  </div>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-[#f5f3f0]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
                [WELCOME TO]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
                Where Luxury Meets <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Nature</span>
              </h2>
            </RevealContent>
            <RevealContent delay={200}>
              <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed max-w-4xl mx-auto px-4">
                Welcome to MAA Srinivasam, perfectly located in the upcoming Isnapur Municipality on Mumbai Highway, offering a harmonious blend of luxury and nature. Experience stunning views of 3 Center Parks and choose from meticulously designed 2 BHK and 3 BHK premium apartments equipped with EV charging points in every parking space.
              </p>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
            <div className="md:col-span-2 relative overflow-hidden rounded-2xl shadow-2xl group h-[300px] sm:h-[400px] md:h-[500px]">
              <RevealImage 
                src={clubhouse}
                alt="Luxury Living Room"
                className="w-full h-full"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 text-white">
                <p className="text-lg sm:text-xl md:text-2xl font-bold drop-shadow-lg">Premium Interiors</p>
                <p className="text-sm sm:text-base text-white/80 drop-shadow-lg">Thoughtfully Designed Spaces</p>
              </div>
            </div>

            <div className="space-y-4 sm:space-y-6">
              <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[145px] sm:h-[190px] md:h-[237px]">
                <RevealImage 
                  src={map1}
                  alt="Modern Kitchen"
                  className="w-full h-full"
                />
                <div className="absolute inset-0 bg-black/30"></div>
              </div>
              <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[145px] sm:h-[190px] md:h-[237px]">
                <RevealImage 
                  src="https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=600"
                  alt="Bedroom"
                  className="w-full h-full"
                />
                <div className="absolute inset-0 bg-black/30"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Auto-Scrolling Gallery Section */}
 <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-white overflow-hidden">
  <div className="max-w-7xl mx-auto mb-8 sm:mb-12">
    <div className="text-center">
      <RevealContent>
        <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
          [GALLERY]
        </span>
      </RevealContent>
      <RevealContent delay={100}>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
          Experience <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Luxury Living</span>
        </h2>
      </RevealContent>
      <RevealContent delay={200}>
        <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed max-w-3xl mx-auto px-4">
          Explore our beautifully designed interiors and premium amenities that make MAA Srinivasam your perfect home
        </p>
      </RevealContent>
    </div>
  </div>

  <div 
    ref={scrollContainerRef}
    className="flex space-x-4 sm:space-x-6 overflow-x-hidden"
    style={{ scrollBehavior: 'smooth' }}
  >
    {[...galleryImages, ...galleryImages].map((image, index) => (
      <div 
        key={index}
        className="flex-shrink-0 w-[250px] sm:w-[350px] md:w-[450px] lg:w-[500px] aspect-square relative overflow-hidden rounded-2xl shadow-xl group"
      >
        <img 
          src={image}
          alt={`Gallery ${index + 1}`}
          className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      </div>
    ))}
  </div>
</section>
      {/* Floor Plans Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-[#f5f3f0]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
                [FLOOR PLANS]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
                Well-Designed <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Floor Plans</span>
              </h2>
            </RevealContent>
            <RevealContent delay={200}>
              <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed max-w-4xl mx-auto px-4">
                Each apartment at MAA SRINIVASAM is crafted to perfection with spacious layouts, premium fittings, and elegant interiors.
              </p>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-12">
            <RevealContent delay={100}>
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden group hover:shadow-2xl transition-all duration-300">
                <div className="relative h-[350px] sm:h-[450px] md:h-[500px] overflow-hidden">
                  <RevealImage 
                    src={floorPlan1}
                    alt="2BHK Floor Plan"
                    className="w-full h-full"
                  />
                </div>
              </div>
            </RevealContent>

            <RevealContent delay={250}>
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden group hover:shadow-2xl transition-all duration-300">
                <div className="relative h-[350px] sm:h-[450px] md:h-[500px] overflow-hidden">
                  <RevealImage 
                    src={floorPlan2}
                    alt="3BHK Floor Plan"
                    className="w-full h-full"
                  />
                </div>
              </div>
            </RevealContent>
          </div>

          <RevealContent delay={400}>
            <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 md:p-12">
              <div className="max-w-4xl mx-auto text-center">
                <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8">
                  If you're planning to buy apartments in Isnapur, MAA SRINIVASAM offers the perfect combination of affordability and opulence.
                </p>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  {[
                    { title: 'Premium Fittings', desc: 'High-quality fixtures and elegant interiors throughout' },
                    { title: 'Optimal Space Utilization', desc: 'Thoughtful design maximizing every square foot' },
                    { title: 'Spacious Layouts', desc: 'Generous living areas with excellent ventilation' },
                    { title: 'Modern Amenities', desc: 'Contemporary facilities for comfortable living' }
                  ].map((item, index) => (
                    <div key={index} className="flex items-start space-x-3 sm:space-x-4 p-4 sm:p-6 bg-[#f5f3f0] rounded-xl hover:shadow-lg transition-shadow duration-300">
                      <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-[#8B7355] flex-shrink-0 mt-1" />
                      <div className="text-left">
                        <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">{item.title}</h4>
                        <p className="text-gray-600 text-xs sm:text-sm">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </RevealContent>
        </div>
      </section>

      {/* Clubhouse Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-400 font-bold mb-4 sm:mb-6 block">
                [WORLD-CLASS AMENITIES]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 px-4">
                15,000 Sq. Ft. Premium Clubhouse
              </h2>
            </RevealContent>
            <RevealContent delay={200}>
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed max-w-3xl mx-auto px-4">
                Experience world-class amenities in our sprawling clubhouse featuring state-of-the-art facilities designed for your comfort and entertainment.
              </p>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {amenities.map((amenity, index) => (
              <RevealContent key={index} delay={index * 100} direction={index % 2 === 0 ? 'left' : 'right'}>
                <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-4 sm:p-6 rounded-2xl hover:bg-white/10 transition-all duration-500 transform hover:-translate-y-2 group">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-[#8B7355] text-white rounded-xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg">
                    {amenity.icon}
                  </div>
                  <h3 className="text-base sm:text-lg md:text-xl font-bold mb-1 sm:mb-2">{amenity.title}</h3>
                  <p className="text-gray-400 text-xs sm:text-sm">{amenity.desc}</p>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* Location & Connectivity */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
                [LOCATION ADVANTAGES]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
                Strategic Location in <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Isnapur</span>
              </h2>
            </RevealContent>
            <RevealContent delay={200}>
              <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed max-w-4xl mx-auto px-4">
                Located in Isnapur, a rapidly growing suburb of Hyderabad, offering unparalleled connectivity and convenience.
              </p>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12">
            {features.map((feature, index) => (
              <RevealContent key={index} delay={index * 100} direction={index % 2 === 0 ? 'up' : 'down'}>
                <div className="bg-[#f5f3f0] p-4 sm:p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 flex items-start space-x-2 sm:space-x-3 group transform hover:-translate-y-1">
                  <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#8B7355] flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform duration-300" />
                  <p className="text-gray-700 font-medium text-xs sm:text-sm md:text-base">{feature}</p>
                </div>
              </RevealContent>
            ))}
          </div>

          <RevealContent delay={800}>
            <div className="relative overflow-hidden rounded-2xl shadow-2xl h-[350px] sm:h-[450px] md:h-[500px] group">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.7441616893837!2d78.19588450000001!3d17.5527712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf12a5f2662cf%3A0xc385d29a5612e332!2sVedamsa%20Infrastructure%20pvt%20ltd!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              ></iframe>
              
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none"></div>
              <div className="absolute bottom-4 sm:bottom-6 md:bottom-8 left-4 sm:left-6 md:left-8 right-4 sm:right-6 md:right-8 pointer-events-auto">
                <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 sm:p-6 shadow-2xl">
                  <div className="flex items-start justify-between flex-col sm:flex-row gap-4">
                    <div className="flex-1">
                      <MapPin className="w-6 h-6 sm:w-8 sm:h-8 text-[#8B7355] mb-2" />
                      <p className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-2">MAA Srinivasam, Isnapur</p>
                      <p className="text-xs sm:text-sm md:text-base text-gray-600 mb-4">Mumbai Highway, Hyderabad - Prime Location</p>
                    </div>
                  </div>
                  <a 
                    href="https://www.google.com/maps/place/Vedamsa+Infrastructure+pvt+ltd/@17.552771,78.195885,10z"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-2 bg-[#8B7355] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold hover:bg-[#6B5744] transition-all duration-300 shadow-lg hover:shadow-xl text-xs sm:text-sm md:text-base"
                  >
                    <span>Get Directions</span>
                    <ExternalLink className="w-4 h-4 sm:w-5 sm:h-5" />
                  </a>
                </div>
              </div>
            </div>
          </RevealContent>
        </div>
      </section>

      {/* Investment Advantages */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-[#f5f3f0]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
                [WHY INVEST]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
                Advantages of Investing in<br className="hidden sm:block" />
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">MAA Srinivasam</span>
              </h2>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            {advantages.map((advantage, index) => (
              <RevealContent key={index} delay={index * 150} direction={index % 2 === 0 ? 'left' : 'right'}>
                <div className="group relative bg-white p-6 sm:p-8 rounded-2xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-[#8B7355]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
                  <div className="relative z-10">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#8B7355]/10 text-[#8B7355] rounded-xl flex items-center justify-center mb-4 sm:mb-6 shadow-md group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                      {advantage.icon}
                    </div>
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 group-hover:text-[#8B7355] transition-colors duration-300">{advantage.title}</h3>
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed">{advantage.desc}</p>
                  </div>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* Vedamsa Legacy */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-gray-900 text-white">
        <div className="max-w-6xl mx-auto text-center">
          <RevealContent>
            <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-400 font-bold mb-4 sm:mb-6 block">
              [TRUSTED BUILDER]
            </span>
          </RevealContent>
          <RevealContent delay={100}>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 sm:mb-8 px-4">
              Vedamsa - Nearly 30 Years of Excellence
            </h2>
          </RevealContent>
          <RevealContent delay={200}>
            <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed max-w-4xl mx-auto mb-8 sm:mb-12 px-4">
              When you think of trust, quality, and reliability in the construction industry, Vedamsa is a name that stands tall in Hyderabad. With nearly three decades of experience, Vedamsa has built a reputation as a premier construction company known for its commitment to customer satisfaction and excellence.
            </p>
          </RevealContent>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8">
            {[
              { number: '30+', text: 'Years of Excellence' },
              { number: '3000+', text: 'Happy Customers' },
              { number: '100%', text: 'Transparency & Trust' }
            ].map((stat, index) => (
              <RevealContent key={index} delay={300 + (index * 100)} direction="up">
                <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 sm:p-8 rounded-2xl hover:bg-white/10 transition-all duration-500 transform hover:-translate-y-2">
                  <p className="text-4xl sm:text-5xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-br from-[#C0C0C0] via-[#E8E8E8] to-[#FFFFFF]">{stat.number}</p>
                  <p className="text-gray-400 text-sm sm:text-base">{stat.text}</p>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="relative h-screen overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-fixed"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

        <div className="relative z-10 h-full flex items-center justify-center px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center text-white">
            <RevealContent>
              <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 drop-shadow-2xl">
                Your Dream Home Awaits
              </h2>
            </RevealContent>
            <RevealContent delay={100}>
              <p className="text-xl sm:text-2xl md:text-3xl text-white mb-3 sm:mb-4 font-light drop-shadow-lg">
                Starting from ₹59.99 Lakhs
              </p>
            </RevealContent>
            <RevealContent delay={200}>
              <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-8 sm:mb-12 drop-shadow-lg">
                2 & 3 BHK Luxury Apartments in Isnapur, Hyderabad
              </p>
            </RevealContent>

            <RevealContent delay={300}>
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
                {/* <button className="group bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 text-base sm:text-lg flex items-center justify-center space-x-2 relative overflow-hidden">
                  <span className="relative z-10 flex items-center space-x-2">
                    <Download className="w-5 h-5 sm:w-6 sm:h-6" />
                    <span>Download Brochure</span>
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-[#C0C0C0] to-[#E8E8E8] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </button> */}
                <button 
  onClick={() => {
    const link = document.createElement('a');
    link.href = brochurePDF;
    link.download = 'MAA-Srinivasam-Brochure.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }}
  className="group bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 text-base sm:text-lg flex items-center justify-center space-x-2 relative overflow-hidden"
>
  <span className="relative z-10 flex items-center space-x-2">
    <Download className="w-5 h-5 sm:w-6 sm:h-6" />
    <span>Download Brochure</span>
  </span>
  <div className="absolute inset-0 bg-gradient-to-r from-[#C0C0C0] to-[#E8E8E8] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
</button>
                <a 
                  href="tel:+918885852266"
                  className="bg-[#8B7355] border-2 border-[#8B7355] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-[#6B5744] hover:border-[#6B5744] transition-all duration-500 shadow-2xl text-base sm:text-lg flex items-center justify-center space-x-2"
                >
                  <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
                  <span className="hidden sm:inline">Call: +91 8885852266</span>
                  <span className="sm:hidden">Call Now</span>
                </a>
              </div>
            </RevealContent>

            <RevealContent delay={400}>
              <div className="mt-8 sm:mt-12 pt-8 sm:pt-12 border-t border-white/30">
                <p className="text-white/90 mb-4 drop-shadow-lg text-sm sm:text-base">For more details or to schedule a site visit:</p>
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center text-white">
                  <a href="tel:+918885852266" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg text-sm sm:text-base">
                    <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span>+91 8885852266</span>
                  </a>
                  <a href="mailto:Vedamsa@gmail.com" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg text-sm sm:text-base">
                    <Mail className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span>Vedamsa@gmail.com</span>
                  </a>
                </div>
              </div>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a1410] text-white py-12 px-4 sm:px-6 relative overflow-hidden">
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: 'linear-gradient(30deg, #8B7355 12%, transparent 12.5%, transparent 87%, #8B7355 87.5%)',
            backgroundSize: '80px 140px'
          }}
        ></div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-8">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
                <div className="bg-gradient-to-br from-[#8B7355] to-[#6B5744] text-white p-2 rounded-lg shadow-lg">
                  <Building2 className="w-6 h-6" />
                </div>
                <span className="text-2xl font-bold">Vedamsa</span>
              </div>
              <p className="text-gray-400 mb-4">Building Dreams, Creating Futures</p>
              <p className="text-gray-500 text-sm">MAA Srinivasam - Luxury Apartments in Isnapur, Hyderabad</p>
            </div>

            <div>
              <h4 className="font-bold mb-4 text-lg">Quick Links</h4>
              <div className="space-y-2 text-gray-400 text-sm">
                <Link to="/" className="block hover:text-white hover:translate-x-1 transition-all duration-300">→ Home</Link>
                <Link to="/about" className="block hover:text-white hover:translate-x-1 transition-all duration-300">→ About</Link>
                <Link to="/contact" className="block hover:text-white hover:translate-x-1 transition-all duration-300">→ Contact</Link>
              </div>
            </div>

            <div>
              <h4 className="font-bold mb-4 text-lg">Contact</h4>
              <div className="space-y-2 text-gray-400 text-sm">
                <p>Isnapur, Hyderabad</p>
                <p>+91 8885852266</p>
                <p>Vedamsa@gmail.com</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 text-center">
            <p className="text-gray-500 text-sm">© 2025 Vedamsa. All rights reserved. | MAA Srinivasam</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MaaSrinivasamPage;